import { render, staticRenderFns } from "./TokenIcon.vue?vue&type=template&id=3fa7c0f2"
import script from "./TokenIcon.vue?vue&type=script&lang=js"
export * from "./TokenIcon.vue?vue&type=script&lang=js"
import style0 from "./TokenIcon.vue?vue&type=style&index=0&id=3fa7c0f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports